const layoutData = [
  {
    name : 'orlandoacadamy',
    layout: {
        layouttype:'layout1',
    }
  },
  {
    name : 'paramount',
    layout: {
        layouttype:'layout2',
    }
  },
  {
    name : 'fitzee',
    layout: {
        layouttype:'layout3',
    }
  },
  {
    name : 'layout4',
    layout: {
        layouttype:'layout4',
    }
  },
  {
    name : 'layout5',
    layout: {
        layouttype:'layout5',
    }
  },
];
export default layoutData;
